import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { axios } from '../../../lib'
import { Customers } from '../types'

type Props = PaginatedParams & {
  sellerId: string
}

export const loadCustomers = (data: Props): PaginatedResponse<Customers> => {
  return axios.get('/customers', {
    params: {
      ...data
    }
  })
}

export function useLoadCustomers(query: Props) {
  return useQuery(['customers', query], () => loadCustomers(query), {
    keepPreviousData: true,
    enabled: !!query?.sellerId,
    onError: () =>
      toast.error('Não foi possível carregar a listagem de clientes', {
        toastId: 'loadCustomers'
      })
  })
}
